import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CreateCheckRecipientRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CreateCheckRecipientResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const createCheckRecipient = (request: CreateCheckRecipientRequest, options?: CashRequestOptions) =>
  post<CreateCheckRecipientRequest, CreateCheckRecipientResponse>('/2.0/cash/create-check-recipient', request, {
    ...options,
    rejectOnError: true,
  })
